import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { NzButtonComponent } from 'ng-zorro-antd/button';
import { AuthService } from '../../shared/services/auth-service/auth.service';

@Component({
  selector: 'login-page',
  standalone: true,
  imports: [CommonModule, NzButtonComponent],
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
  constructor(
    private _auth: AuthService,
    private _router: Router
  ) {}

  login(): void {
    this._auth.login();
    //this._router.navigate(['/dashboard']);
  }
}
